import { useTranslations } from 'next-intl';
import InformativeBox from '@monofront/design-system/components/InformativeBox';
import CharacterHappy from '@monofront/design-system/visuals/Illustrations/CharacterHappy';

const MessageFreeOrder: React.FC = () => {
  const tCheckoutPayment = useTranslations('Checkout.Payment');

  return (
    <InformativeBox
      backgroundColor={'var(--clr-primary-3)'}
      hasImageOnMobile
      icon={<CharacterHappy width={34} height={34} aria-hidden="true" />}
      smallBox={true}
      UNSAFE_className={'tw-mb-5'}
    >
      <p className="tw-lf-body-regular-sm tw-leading-normal">
        {tCheckoutPayment.rich('messageFreeOrder', {
          strong: (children) => <strong>{children}</strong>,
          br: () => <br />,
        })}
      </p>
    </InformativeBox>
  );
};

export default MessageFreeOrder;
